module.exports = __webpack_public_path__ + "img/iconFirstPage.b703757a.svg";